module.exports = {
    RPB: false,
    SOS:false,
    BEW:false,
    SUBSCRIPTION:false,
    LOGIN:false,
    ML:false,
    ICON: false,
    ICONNAME:"",
    RTL :true,
    WATCHHISTORY:false,
    FAVOURITES:false,
    OFFLINE:false,
    Menu:0,
    Cookie:false,
    Gdpr:false,
    Header:"",
    DarkHeader:"",
    CLIENTID:"",
    VCMS:"",
    FSP:"",
    SDP:"",
    PMP:"",
    DHP:"",
    DMP:"",
    DLP:"",
    FLOAT:"none",
    JWAPIKEYV1:"",
    JWAPIKEYV2:"",
    JWAPIKEYV3:"",
    LIVE:"",
    Loader:"Default",
    OTP:false,
    OTPKey:"",
    OFFERS:[],
    APP:"",
    CLM:false,
    CLMURL:"",
    THBTD:"",
    CSM:false,
    CSMURL:"",
    SPL:"",
    SRM:"",
    TITLE:"",
    SITEDESCRIPTION:"",
    WEBICON:"",
    UUID:"",
    WHPL:"",
    RVPL:"",
    SHADING:true,
    TEXTSHADOW:true,
    BORDER:true,
    DARK_MODE:false,
    DARK:false,
    TYPE:"",
    NAME:"",
    LANGUAGE:[],
    DEFAULT_LAN:"en",
    HEADCHAR:170,
    PARACHAR:70,
    YOUHEADCHAR:40,
    YOUPARACHAR:40,
    BACKGROUND:""

  };